import script from "./ArgonTagsInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonTagsInput.vue?vue&type=script&setup=true&lang=js"

import "./ArgonTagsInput.vue?vue&type=style&index=0&id=4187f40d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4187f40d"]])

export default __exports__